import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c1560a8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CompletedMatchScore" }
const _hoisted_2 = { style: {"display":"flex","justify-content":"center","align":"center"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { id: "showCompletedMatchScore" }
const _hoisted_6 = { style: {"display":"flex","justify-content":"space-around","align-items":"center"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Prev ")
const _hoisted_8 = { class: "match-seat-no" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Next ")
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "flex md5 playerNameCenter" }
const _hoisted_12 = { class: "scoreBoardHeadlinePlayerName" }
const _hoisted_13 = { class: "flex md2" }
const _hoisted_14 = { class: "scoreBoardHeadline" }
const _hoisted_15 = { class: "flex md5 playerNameCenter" }
const _hoisted_16 = { class: "scoreBoardHeadlinePlayerName" }
const _hoisted_17 = {
  class: "row",
  style: {"justify-content":"space-around"}
}
const _hoisted_18 = {
  class: "flex md5 mt-4",
  style: {"margin-top":"4px!important"}
}
const _hoisted_19 = { style: {"display":"inline-block","float":"left"} }
const _hoisted_20 = { style: {"float":"right"} }
const _hoisted_21 = { class: "pointRemaining pointRemainingReadOnly" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex md2 mt-4" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "arrowsUsedHeader" })
], -1))
const _hoisted_23 = {
  class: "flex md5 mt-4",
  style: {"margin-top":"4px!important"}
}
const _hoisted_24 = { style: {"display":"inline-block","float":"right"} }
const _hoisted_25 = { style: {"float":"left"} }
const _hoisted_26 = { class: "pointRemaining pointRemainingReadOnly" }
const _hoisted_27 = { class: "three-dart-avg-contains" }
const _hoisted_28 = { class: "three-dart-avg-text" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "three-dart-avg-text" }, "3 Dart Avg")
], -1))
const _hoisted_30 = { class: "three-dart-avg-text" }
const _hoisted_31 = { class: "va-table-responsive scoreTable" }
const _hoisted_32 = {
  class: "va-table va-table--striped scores",
  style: {"width":"100%"}
}
const _hoisted_33 = { class: "center" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "dartsthrown center" }
const _hoisted_37 = { class: "center" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = {
  key: 1,
  class: "data-not-found"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "match-seat-no" }, "data not found", -1))
const _hoisted_42 = [
  _hoisted_41
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_button = _resolveComponent("va-button")!
  const _component_it_divider = _resolveComponent("it-divider")!
  const _component_va_chip = _resolveComponent("va-chip")!
  const _component_va_card = _resolveComponent("va-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_va_button, {
        class: "go-back-btn my-1 mx-2",
        color: "success",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    (_ctx.matchScoreData.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_va_button, {
                class: "go-back-btn my-1 mx-2",
                icon: "arrow_back",
                "icon-color": "#ffffff50",
                color: "primary",
                disabled: _ctx.currentMatch === 0,
                onClick: _cache[1] || (_cache[1] = () => _ctx.currentMatch--)
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createElementVNode("div", null, [
                _createElementVNode("h2", _hoisted_8, "Match Seat " + _toDisplayString(_ctx.currentMatch + 1), 1)
              ]),
              _createVNode(_component_va_button, {
                class: "go-back-btn my-1 mx-2",
                "icon-right": "arrow_forward",
                "icon-color": "#ffffff50",
                color: "primary",
                disabled: _ctx.currentMatch === (_ctx.matchScoreData.length - 1),
                onClick: _cache[2] || (_cache[2] = () => _ctx.currentMatch++)
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h2", _hoisted_12, _toDisplayString(_ctx.setPlayersNameFormate(_ctx.matchScoreData[0].homePlayerName)), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("h2", _hoisted_14, _toDisplayString((_ctx.matchScoreData[_ctx.currentMatch].remainingHomePlayerScore === 0) ? _ctx.matchScoreData[_ctx.currentMatch].homeTotalwins + 1 : _ctx.matchScoreData[_ctx.currentMatch].homeTotalwins) + " - " + _toDisplayString((_ctx.matchScoreData[_ctx.currentMatch].remainingAwayPlayerScore === 0) ? _ctx.matchScoreData[_ctx.currentMatch].awayTotalwins + 1 : _ctx.matchScoreData[_ctx.currentMatch].awayTotalwins), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("h2", _hoisted_16, _toDisplayString(_ctx.setPlayersNameFormate(_ctx.matchScoreData[0].awayPlayerName)), 1)
              ]),
              _createVNode(_component_it_divider)
            ])
          ]),
          _createVNode(_component_va_card, {
            color: "#afcfff",
            stripe: "",
            "stripe-color": "#ab0033"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, [
                      _createVNode(_component_va_chip, {
                        class: "pointRemainingChip pointRemainingChipReadOnly",
                        color: (_ctx.matchScoreData[_ctx.currentMatch].remainingHomePlayerScore === 0) ? '#fff' : '#ab0033',
                        square: "",
                        readonly: ""
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", _hoisted_21, _toDisplayString(_ctx.matchScoreData[_ctx.currentMatch].remainingHomePlayerScore), 1)
                        ]),
                        _: 1
                      }, 8, ["color"])
                    ])
                  ])
                ]),
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("span", _hoisted_24, [
                    _createElementVNode("span", _hoisted_25, [
                      _createVNode(_component_va_chip, {
                        class: "pointRemainingChip pointRemainingChipReadOnly",
                        color: (_ctx.matchScoreData[_ctx.currentMatch].remainingAwayPlayerScore === 0) ? '#fff' : '#ab0033',
                        square: "",
                        readonly: ""
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", _hoisted_26, _toDisplayString(_ctx.matchScoreData[_ctx.currentMatch].remainingAwayPlayerScore), 1)
                        ]),
                        _: 1
                      }, 8, ["color"])
                    ])
                  ])
                ])
              ]),
              _createVNode(_component_it_divider),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_28, _toDisplayString(_ctx.threeDartAvg(1)), 1)
                ]),
                _hoisted_29,
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_30, _toDisplayString(_ctx.threeDartAvg(0)), 1)
                ])
              ]),
              _createVNode(_component_it_divider),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("table", _hoisted_32, [
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortTheMatchScoreOnPosition(_ctx.matchScoreData[_ctx.currentMatch].kamp_saet_scores), (matchSetScore, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_33, [
                          (_ctx.checkForRoundPlayed(index, 1))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, "---"))
                            : (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(matchSetScore.homePlayerScore), 1))
                        ]),
                        _createElementVNode("td", _hoisted_36, _toDisplayString(matchSetScore.darts), 1),
                        _createElementVNode("td", _hoisted_37, [
                          (_ctx.checkForRoundPlayed(index, 0))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, "---"))
                            : (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(matchSetScore.awayPlayerScore), 1))
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_42))
  ]))
}